
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";

@Component({
  name: "SelectCustomerDialog",
})
export default class extends Vue {
  @Prop({ default: false }) private visible!: boolean;

  private dialogVisible = false;
  private loading = false;
  private selectedId: string = null;
  private selectedCustomer: { id: string; code: string; abbreviation: string } = null;
  private options: any[] = [];

  @Watch("visible", { immediate: true })
  private onVisibleChange(val: boolean) {
    this.dialogVisible = val;
    if (val) {
      this.selectedId = null;
      this.selectedCustomer = null;
      this.options = [];
      this.remoteSearch("");
    }
  }

  private formatLabel(item: any) {
    return `${item.code || ""} ${item.abbreviation || ""}`.trim();
  }

  private async remoteSearch(keyword: string) {
    this.loading = true;
    try {
      const res: any = await searchCustomer({ keyword: keyword || "" });
      this.options = Array.isArray(res) ? res : [];
    } catch (e) {
      this.options = [];
    } finally {
      this.loading = false;
    }
  }

  private onSelectChange(id: string) {
    const found = this.options.find((item) => item.id === id);
    this.selectedCustomer = found
      ? {
          id: found.id,
          code: found.code,
          abbreviation: found.abbreviation,
        }
      : null;
  }

  private handleClose() {
    this.$emit("update:visible", false);
  }

  private handleConfirm() {
    if (!this.selectedCustomer) {
      this.$message.warning("请选择客人");
      return;
    }
    this.$emit("confirm", this.selectedCustomer);
    this.$emit("update:visible", false);
  }
}
